module.exports = __webpack_public_path__ + "img/20200609_113913.3dede49b.jpg";